export default __webpack_public_path__ + "static/media/2425 knife block B side.0af57b1a.png";